import { Utag, UtagData } from '../models/analytics'
import { User } from '../Techedge-digitalportal-shared'
import { UserHelper } from './userHelper'

declare const utag: Utag
declare let utag_data: UtagData
declare const tealium_data2track: any[]

export class Analytics {
    public static _getDeviceType(ua: string) {
        if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(ua)) {
            return 'T'
        }
        if (
            /Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(
                ua
            )
        ) {
            return 'M'
        }
        return 'D'
    }

    public static _sendAnalyticsLinkEvent(
        pageSection1: string,
        pageSection2: string,
        pageType = '',
        user?: User
    ) {
        let newData: UtagData
        if (window.hasOwnProperty('utag_data')) {
            const userData = UserHelper._shared().user() || user
            if (!!userData.user_id && Array.isArray(userData.brand_region)) {
                const language = navigator.language.split('-')[0].toUpperCase()
                const brandRetail = userData.brand_region
                    .reduce(
                        (prev, curr) =>
                            prev +
                            (prev.indexOf(curr.retail_brand) < 0
                                ? ',' + curr.retail_brand
                                : ''),
                        ''
                    )
                    .substring(1)
                newData = {
                    Page_Language: language,
                    Page_Country: language,
                    Page_DeviceType: Analytics._getDeviceType(
                        navigator.userAgent
                    ),
                    User_Id: userData.user_id,
                    User_Country: userData.region,
                    '1LX_User_BusinessFuntion': userData.business_function,
                    '1LX_User_BrandRetail': brandRetail,
                    Store_Id: userData.store ? userData.store.store_id : '',
                    Region: userData.store ? userData.store.region : '',
                    Macroregion: userData.store
                        ? userData.store.macroregion
                        : '',
                    App_Group: userData.role,
                    SO: navigator.platform,
                    Browser_Version: navigator.userAgent,
                }
            }
            newData = !newData ? <UtagData>{} : newData
            newData.Page_Section1 = pageSection1
            newData.Page_Section2 = pageSection2
            newData.Page_Type = pageType
            newData.id = 'VirtualPage-View'
            if (window.hasOwnProperty('utag')) {
                tealium_data2track.push(newData)
            }
        }
    }

    public static _sendAnalyticsClickEvent(
        elementId: string,
        description: string
    ) {
        if (window.hasOwnProperty('utag_data')) {
            tealium_data2track.push({
                id: 'Click',
                Tracking_Type: 'link',
                data_element_id: elementId, // max 25 characters
                data_description: description, // max 25 characters
            })
        }
    }
}
